import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex text-sm text-[#fff]" }
const _hoisted_2 = ["src", "alt"]
const _hoisted_3 = {
  key: 1,
  id: "icon",
  class: "px-2 mr-0 py-0.5 h-auto w-auto bg-[#041e42] rounded-none",
  style: {"text-transform":"capitalize"}
}
const _hoisted_4 = {
  key: 2,
  class: "px-2 py-0.5 bg-[#36a8dd]"
}
const _hoisted_5 = {
  key: 3,
  class: "px-2 py-0.5 bg-[#36a8dd]"
}

import { onMounted } from 'vue';
import Chip from 'primevue/chip';
import 'primeicons/primeicons.css';


export default /*#__PURE__*/_defineComponent({
  __name: 'FilterTags',
  props: ['filterValue', 'nameKey', 'icon', 'index', 'type'],
  setup(__props) {

const props = __props


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Chip), { class: "p-0 bg-grey mr-3" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (__props.icon != null)
          ? (_openBlock(), _createElementBlock("img", {
              key: 0,
              id: "icon",
              class: "px-2 ml-0 mr-0 py-0.5 w-[2.3rem] bg-[#041e42] rounded-none",
              style: {"text-transform":"capitalize"},
              src: __props.icon,
              alt: props.type
            }, null, 8, _hoisted_2))
          : (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(props.type), 1)),
        (__props.filterValue[__props.nameKey])
          ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(__props.filterValue[__props.nameKey]), 1))
          : (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(__props.filterValue[Object.keys(__props.filterValue)[0]]), 1)),
        _createElementVNode("button", {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('remove-tag'))),
          class: "pi pi-times-circle text-black text-md p-1 items-center"
        })
      ])
    ]),
    _: 1
  }))
}
}

})